export function isSurveyEnabled(survey) {
    return !survey.disabled && Boolean(survey._id);
}
